import { apiErrorFromEnvelope } from './errors';

/**
 * Standard JSON envelope returned by the platform REST API (`success`, `data`, `requestId`, …).
 *
 * Success: `{ success: true, statusCode, data, requestId? }`
 * Error:   `{ success: false, statusCode, error: { code, message, details? }, requestId? }`
 */
export interface ApiEnvelope<T> {
  success?: boolean;
  statusCode?: number;
  data?: T;
  message?: string;
  error?: {
    code?: string;
    message?: string;
    details?: unknown;
  };
  requestId?: string;
}

/** Inner body for refresh-token responses inside the envelope. */
export interface RefreshTokensPayload {
  accessToken: string;
  refreshToken: string;
}

/**
 * Unwrap a successful envelope's `data` payload.
 * Throws {@link ApiError} with full gateway code/message/details/requestId on failure.
 */
export function unwrapEnvelopeData<T>(body: unknown, httpStatus: number): T {
  const b = body as ApiEnvelope<T>;

  if (!b || typeof b !== 'object') {
    throw apiErrorFromEnvelope(body, httpStatus);
  }

  if (b.success === false || b.data === undefined) {
    throw apiErrorFromEnvelope(
      body,
      typeof b.statusCode === 'number' && b.statusCode > 0 ? b.statusCode : httpStatus,
    );
  }

  return b.data;
}
